"use strict";

define(['app', 'selectize'], function (app) {
  return app.Marionette.ItemView.extend({
    template: false,
    options: {
      create: false
    },
    initialize: function initialize(options) {
      var self = this;
      self.$el.selectize({
        create: options.create
      });

      if (self.$el.data('refresh')) {
        self.$el.on('change', function () {
          window.location.replace(this.value);
        });
      }
    }
  });
});